import BaseApiController from 'controller/baseresourcecontroller';

export default class PurchaseReceiptController extends BaseApiController {
  constructor () {
    super('mvc/purchasereceipt');
  }
  /**
   * @param  {Number} autoid AutoID
   */
  async GetByAutoID (autoid) {
    return super.Post('get', { autoid: autoid });
  }
  /**
   * @param  {String} id ID
   */
  async GetByID (id) {
    return super.Post('GetByID', { id: id });
  }
  /**
   * @param  {Number} autoid PurchaseReceipt.AutoID
   * @param  {Number} purchasereceiptitemid PurchaseReceiptItem.AutoID
   */
  async RemoveItem (autoid, purchasereceiptitemid) {
    return super.Post('RemoveItem', { autoid: autoid, purchaseReceiptItemID: purchasereceiptitemid });
  }
  /**
   * @param  {Number} autoid PurchaseReceipt.AutoID
   */
  async Process (autoid) {
    return super.Post('process', { autoid: autoid });
  }

  async GetNew () {
    return super.Get('getnew');
  }

  async Create (obj) {
    return super.Post('create', obj);
  }

  async Update (obj) {
    return super.Post('update', obj);
  }

  /**
   * @param  {Number} autoid PurchaseReceipt.AutoID
   */
  async Delete (autoid) {
    return super.Post('delete', { autoid: autoid });
  }

  /**
   * @param  {Number} purchaseReceiptID
   * @param  {Number} articleID
   * @param  {Number} purchaseOrderLineID
   * @param  {Number} locationID
   * @param  {Number} quantity
   */
  async AddBulkItem (purchaseReceiptID, articleID, purchaseOrderLineID, locationID, quantity) {
    let obj = {
      purchaseReceiptID: purchaseReceiptID,
      articleID: articleID,
      purchaseOrderLineID: purchaseOrderLineID,
      locationID: locationID,
      quantity: quantity
    };
    return super.Post('addbulkitem', obj);
  }

  /**
   * @param  {Number} purchaseReceiptID
   * @param  {Number} articleID
   * @param  {Number} purchaseOrderLineID
   * @param  {Number} locationID
   * @param  {Number} Object00
   */
  async AddUniqueItem (purchaseReceiptID, articleID, purchaseOrderLineID, locationID, Object00) {
    let obj = {
      purchaseReceiptID: purchaseReceiptID,
      articleID: articleID,
      purchaseOrderLineID: purchaseOrderLineID,
      locationID: locationID,
      Object00: Object00
    };
    return super.Post('adduniqueitem', obj);
  }

  /**
   * Add non stock item
   * @param  {Number} purchaseReceiptID PurchaseReceipt.AutoID
   * @param  {Number} articleID
   * @param  {Number} purchaseOrderLineID
   * @param  {Number} quantity
   */
  async AddNonStockItem (purchaseReceiptID, articleID, purchaseOrderLineID, quantity) {
    let obj = {
      purchaseReceiptID: purchaseReceiptID,
      articleID: articleID,
      purchaseOrderLineID: purchaseOrderLineID,
      quantity: quantity
    };
    return super.Post('AddNonStockItem', obj);
  }

  /**
   * @param  {Number} purchaseReceiptID PurchaseReceipt.AutoID
   * @param  {Number} purchaseReceiptItemID PurchaseReceiptItem.AutoID
   * @param  {Number} locationID PurchaseReceipt.LocationID
   * @param  {Number} quantity Quantity
   */
  async ChangeReceiptItem (purchaseReceiptID, purchaseReceiptItemID, locationID, quantity) {
    let obj = {
      purchaseReceiptID: purchaseReceiptID,
      purchaseReceiptItemID: purchaseReceiptItemID,
      locationID: locationID,
      quantity: quantity
    };
    return super.Post('ChangeReceiptItem', obj);
  }

  async ExportData(data) {
    return super.Post(`ExportData`, { data: data });
  }
  async ValidateBulkReceipts (requests) {
    return super.Post('ValidateBulkReceipts', { requests: requests });
  }

  async AddBulk (item) {
    return super.Post('AddBulk', item);
  }
}
